import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import type { GenerationModelDetailFragment } from 'src/services/apollo/generated/graphql'
import {
  isUserLora as checkIsUserLora,
  isLoraCategoryNotSet,
} from 'src/utils/model'
import { isModelPrivate } from '~/utils/generationModel/modelPermissions'
import { dialogEditModel } from '../GenerationModelEdit/ModelEditDialog'
import { publishLora } from '../helpers'

export function PublishOrEditUserLoraButton(props: {
  className?: string
  mutate?: () => any
  model: GenerationModelDetailFragment
}) {
  const { model, className, mutate } = props
  const { t } = useTranslation(['market', 'action'])

  const isUserLora = checkIsUserLora(model.type)
  if (!isUserLora) return null

  const categoryReady = !isLoraCategoryNotSet(model)
  const publishable = isModelPrivate(model) && categoryReady

  return (
    <Button
      variant="contained"
      className={className}
      onClick={async e => {
        e.preventDefault()
        e.stopPropagation()
        if (publishable) {
          const result = await publishLora(model.id)
          if (result) {
            mutate?.()
          }
        } else {
          dialogEditModel({
            model,
            mutate,
            highlightId: categoryReady ? undefined : 'category-field',
          })
        }
      }}
    >
      {publishable ? t('action:publish') : t('action:edit')}
    </Button>
  )
}
